import {useGTMDispatch} from './react-gtm-hook/index'
import {capitalize} from '../utils/utils'
import {getComponentName} from './utils'

export const DELIVERY_CARD_CONTENT_NAMES = {
  sameDay: 'Same day',
  nextDay: 'Next Day',
  rapid: 'Rapid',
  prebook: 'Pre-Book'
}

const SELECT_DELIVERY_CONTENT_ID = 'Select Delivery Banner'
const SELECT_DELIVERY_CONTENT_TYPE = 'feature-card'
const FEATURE_PROMPT_CONTENT_TYPE = 'feature-prompt'

export const sendDeliveryFeatureCardSelectContent = (sendDataToGTM, {contentName, contentUrl}) => {
  if (!contentName) {
    return
  }

  setTimeout(() => {
    try {
      sendDataToGTM({
        event: 'select_content',
        content_id: SELECT_DELIVERY_CONTENT_ID,
        content_type: SELECT_DELIVERY_CONTENT_TYPE,
        content_name: contentName,
        content_url: contentUrl ?? ''
      })
    } catch (error) {
      console.error('sendDeliveryFeatureCardSelectContent error within setTimeout: ' + error.message)
    }
  }, 0)
}

export const useDeliveryCardTracking = () => {
  const sendDataToGTM = useGTMDispatch()

  return ({contentName, contentUrl}) => {
    sendDeliveryFeatureCardSelectContent(sendDataToGTM, {contentName, contentUrl})
  }
}

export const sendFeaturePromptSelectContent = (sendDataToGTM, {contentId, contentName, contentUrl}) => {
  if (!contentId || !contentName) {
    return
  }

  setTimeout(() => {
    try {
      sendDataToGTM({
        event: 'select_content',
        content_id: contentId,
        content_type: FEATURE_PROMPT_CONTENT_TYPE,
        content_name: contentName,
        content_url: contentUrl ?? ''
      })
    } catch (error) {
      console.error('sendFeaturePromptSelectContent error within setTimeout: ' + error.message)
    }
  }, 0)
}

export const useFeaturePromptTracking = () => {
  const sendDataToGTM = useGTMDispatch()

  return ({contentId, contentName, contentUrl}) => {
    sendFeaturePromptSelectContent(sendDataToGTM, {contentId, contentName, contentUrl})
  }
}

export const useSelectContentTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const sendSelectContentData = (content) => {
    if (!content) {
      return null
    }

    const schema = content?._meta?.schema
    const component = schema ? getComponentName(schema).replaceAll('-', ' ') : 'component'
    const componentCapitalized = capitalize(component)
    setTimeout(() => {
      try {
        sendDataToGTM({
          event: 'select_content',
          ecommerce: {
            content_id: content?._meta?.name ?? 'Missing content identifier',
            content_type: componentCapitalized ?? 'Missing content type',
          }
        })
      } catch (error) {
        console.error('useSelectContentTracking error within setTimeout: ' + error.message)
      }
    })
  }
  return sendSelectContentData
}